import React from 'react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import WeeklyTimekeeping from './WeeklyTimekeeping';

const TimekeepingGridView = ({ flags }) => (
  <Box sx={{ padding: '24px' }}>
    <WeeklyTimekeeping flags={flags} />
  </Box>
);
export default withLDConsumer()(TimekeepingGridView);

TimekeepingGridView.propTypes = {
  flags: PropTypes.shape({}),
};
